module.exports = __webpack_public_path__ + "static/WEDDING E&M-416-5ae43b0924c09f9c2d64f5781ae3808c.jpg";